export enum EActionDialog {
  GenerateFleetLegalReport = "generateFleetLegalReport",
  GenerateHullOnLandReport = "generateHullOnLandReport",
  GenerateMachineryBreakdownReport = "generateMachineryBreakdownReport",
  AddPremium = "addPremium",
  AdjustDeductible = "adjustDeductible",
  Adjustment = "adjustment",
  ChangeDueDate = "changeDueDate",
  CopySettings = "copySettings",
  CreateSetting = "createSetting",
  EditSetting = "editSetting",
  GenerateComparisonReport = "generateComparisonReport",
  GenerateCoversheetReport = "generateCoversheetReport",
  Index = "index",
  UpdateFleetPremiumForEngineTax20250401 = "updateFleetPremiumForEngineTax20250401",
  UpdateFleetPremiumDocumentDate = "updateFleetPremiumDocumentDate",
  PaymentMethodChange = "paymentMethodChange",
  ReadOnly = "readOnly",
  RecalculateProRataAndBookings = "recalculateProRataAndBookings",
  RemovePremium = "removePremium",
  ContinuePremium = "continuePremium",
  DeletePremium = "deletePremium",
  SynchronizeFleetClient = "synchronizeFleetClient",
  SynchronizeFleetInsurer = "synchronizeFleetInsurer",
  UpdatePremium = "updatePremium",
  ExportFleet = "exportFleet",
  UploadFleetVehicles = "uploadFleetVehicles",
}

export enum EDialogAttributeName {
  AnnualGrossPremium = "annualGrossPremium",
  Deductible = "deductible",
  Calculation = "calculation",
  MbCalculation = "mbCalculation",
  // CZ only
  MtplInsuranceLimits = "mtplInsuranceLimits",
  HullDeductibleOptions = "hullDeductibleOptions",
  AssistanceOptions = "assistanceOptions",
}
